document.addEventListener('DOMContentLoaded', function () {
  const tierThreeDivs = document.querySelectorAll('div.tier_three[data-menu-title]');

  tierThreeDivs.forEach(tierDiv => {
    const title = tierDiv.getAttribute('data-menu-title');
    const triggerLink = document.querySelector(`a[data-menu-title="${title}"]`);
// console.log(tierDiv,"-------->",title,"-=-=-=-=-=", triggerLink,"=======>");
    if (triggerLink) {
      tierDiv.style.display = 'none';
      tierDiv.style.position = 'fixed';
      tierDiv.style.zIndex = '999';

      let hideTimeout;

      const showMenu = () => {
        clearTimeout(hideTimeout);
        tierDiv.style.display = 'flex';
        document.body.classList.add("no-scroll"); 
      };

      const hideMenu = () => {
        hideTimeout = setTimeout(() => {
          tierDiv.style.display = 'none';
          document.body.classList.remove("no-scroll");
        }, 100);
      };

      triggerLink.addEventListener('mouseenter', showMenu);
      triggerLink.addEventListener('mouseleave', hideMenu);

      tierDiv.addEventListener('mouseenter', showMenu);
      tierDiv.addEventListener('mouseleave', hideMenu);

      document.body.appendChild(tierDiv); // or triggerLink.parentNode.appendChild(tierDiv);
    }
  });
});

// document.addEventListener('DOMContentLoaded', function () {
//   const tierThreeDivs = document.querySelectorAll('div.tier_three[data-menu-title]');

//   tierThreeDivs.forEach(tierDiv => {
//     const title = tierDiv.getAttribute('data-menu-title');
//     const triggerLink = document.querySelector(`a[data-menu-title="${title}"]`);

//     if (triggerLink) {
//       tierDiv.style.display = 'none';
//       tierDiv.style.position = 'fixed';
//       tierDiv.style.zIndex = '999';

//       triggerLink.addEventListener('mouseenter', () => {
//         tierDiv.style.display = 'flex';
//       });

//       triggerLink.addEventListener('mouseleave', () => {
//         tierDiv.style.display = 'none';
//       });

//       tierDiv.addEventListener('mouseleave', () => {
//         tierDiv.style.display = 'none';
//       });

//       tierDiv.addEventListener('mouseenter', () => {
//         tierDiv.style.display = 'flex';
//       });

//       // document.body.appendChild(tierDiv); // or 
//       triggerLink.parentNode.appendChild(tierDiv);
//     }
//   });
// });


// document.addEventListener('DOMContentLoaded', function () {
//   const tierThreeDivs = document.querySelectorAll('div.tier_three[data-menu-title]');

//   tierThreeDivs.forEach(tierDiv => {
//     const title = tierDiv.getAttribute('data-menu-title');
//     const triggerLink = document.querySelector(`a[data-menu-title="${title}"]`);

//     if (triggerLink) {
//       // Initially hide the tier_three div
//       tierDiv.style.display = 'none';
//       tierDiv.style.position = 'fixed'; // stays on screen relative to viewport
//       tierDiv.style.zIndex = '999';

//       // Add hover events
//       triggerLink.addEventListener('mouseenter', () => {
//         tierDiv.style.display = 'flex';
//       });

//       triggerLink.addEventListener('mouseleave', () => {
//         setTimeout(() => {
//           if (!tierDiv.matches(':hover')) {
//             tierDiv.style.display = 'none';
//           }
//         }, 100);
//       });

//       tierDiv.addEventListener('mouseenter', () => {
//         tierDiv.style.display = 'flex';
//       });

//       tierDiv.addEventListener('mouseleave', () => {
//         tierDiv.style.display = 'none';
//       });

//       // ✅ Append after the link
//       triggerLink.insertAdjacentElement('afterend', tierDiv);
//     }
//   });
// });

// document.addEventListener('DOMContentLoaded', function () {
//   const tierThreeDivs = document.querySelectorAll('div.tier_three[data-menu-title]');

//   tierThreeDivs.forEach(tierDiv => {
//     const title = tierDiv.getAttribute('data-menu-title');
//     const triggerLink = document.querySelector(`a[data-menu-title="${title}"]`);

//     if (triggerLink) {
//       const tierParent = tierDiv.parentElement; // Get the parent of tierDiv

//       // Set styles on the tierDiv itself
//       tierDiv.style.display = 'none';
//       tierDiv.style.position = 'fixed'; // fixed to viewport
//       tierDiv.style.zIndex = '999';

//       // Hover behavior
//       triggerLink.addEventListener('mouseenter', () => {
//         tierDiv.style.display = 'flex';
//         tierParent.style.display = 'flex';
//       });

//       triggerLink.addEventListener('mouseleave', () => {
//         setTimeout(() => {
//           if (!tierDiv.matches(':hover')) {
//             tierDiv.style.display = 'none';
//             tierParent.style.display = 'none';            
//           }
//         }, 100);
//       });

//       tierDiv.addEventListener('mouseenter', () => {
//         tierDiv.style.display = 'flex';
//         tierParent.style.display = 'flex';
//       });

//       tierDiv.addEventListener('mouseleave', () => {
//         tierDiv.style.display = 'none';
//       });

//       // ✅ Append the parent of tierDiv after the triggerLink
//       if (tierParent) {
//         triggerLink.insertAdjacentElement('afterend', tierParent);
//       }
//     }
//   });
// });

 



